module.exports = __webpack_public_path__ + "img/SYM05.abaf4418.gif";